import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { postAuthSession } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Plane } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const me = await postAuthSession(sessionId);
        setUser(me);
      } catch (e) {
        console.error("Auth failed", e);
      } finally {
        // Clear hash and go home
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FBFBFD]">
      <div className="flex flex-col items-center gap-4">
        <Plane className="w-8 h-8 text-[#4FB3E8] animate-pulse" />
        <p className="text-sm text-gray-500">Mengesahkan log masuk…</p>
      </div>
    </div>
  );
}
